import { Routes, Router } from '@angular/router';
import { OktaAuthGuard } from '@tmhcc-ng-lib/framwork/okta-login';
import { SaveChangeGaurd } from '@tmhcc-ng-lib/global-services';
import { GeneralLiabilityUCMComponent } from './ucm-forms/general-liability/gl-ucm-forms.component';
import { PollutionLiabilityUCMComponent } from './ucm-forms/pollution-liability/pl-ucm-forms.component';
import { ProfessionalLiabilityUCMComponent } from './ucm-forms/professional-liability/pr-ucm-forms.component';
import { BuildersRiskUCMComponent } from './ucm-forms/builders-risk/br-ucm-forms.component';
import { ExcessLiabilityUCMComponent } from './ucm-forms/excess-liability/ex-ucm-forms.component';
import { ContractorsEquipmentUCMComponent } from './ucm-forms/contractors-equipment/ce-ucm-forms.component';
import { AddressChangeUCMComponent } from './ucm-forms/address-change/ac-ucm-forms.component';
import { ExposureChangeUCMComponent } from './ucm-forms/exposure-change/ec-ucm-forms.component';
import { ClassifiactionChangeUCMComponent } from './ucm-forms/classifiaction-change/cc-ucm-forms.component';
export function onAuthRequired(injector) {
  const router = injector.get(Router);
  router.navigate(['/login']);
}

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [OktaAuthGuard],
    data: {
      onAuthRequired
    }
  },
  {
    path: 'request-access',
    loadChildren: () =>
      import('./support-request/support-request.module').then(
        m => m.SupportRequestModule
      )
  },
  {
    path: 'news-feed',
    loadChildren: () =>
      import('./news-feed/news-feed.module').then(m => m.NewsFeedModule),
    canActivate: [OktaAuthGuard],
    data: {
      onAuthRequired
    }
  },
  {
    path: 'thank-you',
    loadChildren: () =>
      import('./thank-you/thank-you.module').then(m => m.ThankYouModule)
  },
  {
    path: 'farmers-thank-you',
    loadChildren: () =>
      import('./farmers-thank-you/farmers-thank-you.module').then(
        m => m.FarmersThankYouModule
      )
  },
  {
    path: 'bind',
    loadChildren: () =>
      import('./bind-info/bind-info.module').then(m => m.BindInfoModule),
    canActivate: [OktaAuthGuard],
    data: {
      onAuthRequired
    }
  },
  {
    path: 'bound',
    loadChildren: () =>
      import('./bound-policy/bound-policy.module').then(
        m => m.BoundPolicyModule
      ),
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'declined',
    loadChildren: () =>
      import('./declined/declined.module').then(m => m.DeclainedModule),
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'ucm-forms/:id',
    component: GeneralLiabilityUCMComponent,
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'pl-ucm-forms/:id',
    component: PollutionLiabilityUCMComponent,
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'pr-ucm-forms/:id',
    component: ProfessionalLiabilityUCMComponent,
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'ac-ucm-forms/:id',
    component: AddressChangeUCMComponent,
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'ec-ucm-forms/:id',
    component: ExposureChangeUCMComponent,
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'cc-ucm-forms/:id',
    component: ClassifiactionChangeUCMComponent,
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'br-ucm-forms/:id',
    component: BuildersRiskUCMComponent,
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'ex-ucm-forms/:id',
    component: ExcessLiabilityUCMComponent,
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'ce-ucm-forms/:id',
    component: ContractorsEquipmentUCMComponent,
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'general',
    loadChildren: () =>
      import('./general-liability/general-liability.module').then(
        m => m.GeneralLiabilityModule
      ),
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'pollution',
    loadChildren: () =>
      import('./pollution-liability/pollution-liability.module').then(
        m => m.PollutionLiabilityModule
      ),
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'professional',
    loadChildren: () =>
      import('./professional-liability/professional-liability.module').then(
        m => m.ProfessionalLiabilityModule
      ),
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'builders',
    loadChildren: () =>
      import('./builders-risk/builders-risk.module').then(
        m => m.BuildersRiskModule
      ),
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'excess',
    loadChildren: () =>
      import('./excess-liability/excess-liability.module').then(
        m => m.ExcessLiabilityModule
      ),
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'contractors',
    loadChildren: () =>
      import('./contractors-equipment/contractors-equipment.module').then(
        m => m.ContractorsEquipmentModule
      ),
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  },
  {
    path: 'shared',
    loadChildren: () =>
      import('./shared-module/shared-module.module').then(
        m => m.SharedModuleModule
      ),
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: {
      onAuthRequired
    }
  },
  {
    path: 'additional',
    loadChildren: () =>
      import('./additional-insured/additional-insured.module').then(
        m => m.AdditionalInsuredModule
      ),
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: {
      onAuthRequired
    }
  },
  {
    path: 'pending-review',
    loadChildren: () =>
      import('./en-pending-review/en-pending-review.module').then(
        m => m.EnPendingReviewModule
      ),
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: {
      onAuthRequired
    }
  },
  {
    path: 'contact-us',
    loadChildren: () =>
      import('./contact-us/contact-us.module').then(m => m.ContactUsModule),
    canActivate: [OktaAuthGuard],
    data: {
      onAuthRequired
    }
  },
  {
    path: 'agency-request',
    loadChildren: () =>
      import('./agency-request/agency-request.module').then(
        m => m.AgencyRequestModule
      )
  },
  {
    path: 'account-settings',
    loadChildren: () =>
      import('./account-settings/account-settings.module').then(
        m => m.AccountSettingsModule
      ),
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: {
      onAuthRequired
    }
  },
  {
    path: 'agency-admin',
    loadChildren: () =>
      import('./agency-admin/agency-admin.module').then(
        m => m.AgencyAdminModule
      ),
    canActivate: [OktaAuthGuard],
    canDeactivate: [SaveChangeGaurd],
    data: { onAuthRequired }
  }
];

export const ArtisanEdgeRoutes = routes;
